import axios from "axios";
import {
  getDataFromLocalStorage,
  validateToken,
} from "../components/App/utils/util";
import { toast } from "react-toastify";

const instance = axios.create({
  // baseURL: "https://api.isamtree.com/", // "https://run.mocky.io/v3"
  baseURL: process.env.REACT_APP_BASE_URL, // "https://run.mocky.io/v3"
  // timeout: 6000,
  // headers: {Authorization: `Bearer ${getDataFromLocalStorage("access_token")}`}
});
// axios.defaults.baseURL = process.env.REACT_APP_BASE_URL;

// console.log( process.env.REACT_APP_BASE_URL)
instance.interceptors.request.use((req: any) => {
  if (req.url === "admin/refresh") return req;
  if (validateToken()) {
    const token = getDataFromLocalStorage("access_token");
    const auth = token ? `Bearer ${token}` : "";
    req.headers.common["Authorization"] = auth;
  }
  return req;
});

instance.interceptors.response.use(
  (res: any) => {
    console.debug("Response interceptor SUCCESS triggered:", res.status, res.config?.url);
    try {
      if (res.status === 200 || res.status === 204 || res.status === 202) {
        return res;
      } else if(res.status === 401) {

        return "Session expired. Please login again."
      }
      else if (res.data !== "") {
        toast.error("Somthing went wrong.");
      } else {
        toast.error("Somthing went wrong.");
      }
    } catch (err) {
      console.log("Error in response interceptor:", err);
      toast.error(res.message);
    }
    return res;
  },
  (error: any) => {
    switch(error.response?.status) {
      case 401:
        return Promise.reject(error)
      default:
        console.log("Response interceptor ERROR triggered:", error.response?.status, error.config?.url);
        return Promise.reject(error);
    }
  }
);

export default instance;
